import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./TabButton.css"

function TabButton({ to, exact, title, icon, onClick, linkButton, isSelected, count }) {
    const isLink = linkButton || true

    const renderContent = (
        <>
        { icon !== undefined ?
        <FontAwesomeIcon 
        style={{ marginRight: 10 }}
        icon={icon}/> : null
        }
        <span>{title}</span>
        { count > 0 ?
        <span className="noti-count">
            {count}
        </span>
        : null
        }
        </>
    )

    return (
        <>
        { isLink && to !== undefined ?
            <NavLink 
            exact={exact}
            to={to} 
            activeClassName="navlink-active"
            onClick={onClick}
            className="navlink">
                {renderContent}
            </NavLink>
        :
            <div 
            className={isSelected ? "navlink navlink-active": "navlink"}
            role="button"
            tabIndex="0"
            aria-pressed="false"
            onKeyDown={(e)=>{
                if(e.key === "Enter"){
                    onClick()
                }
            }}
            onClick={onClick}>
                {renderContent}
            </div>
        }
        </>
    )
}

export default TabButton
